import * as React from 'react';
import {Provider} from 'react-redux';
import {store} from './store';
import {UsersDashboardComponent} from './Dashboard'


export function UsersDashboardContainer() {

  return (
    <Provider store={store}>
      <UsersDashboardComponent />
    </Provider>
  )
}
